import moment from "moment";
import React, { useEffect, useState } from "react";
import { ImNewTab } from "react-icons/im";
import { LuArchiveRestore } from "react-icons/lu";
import { MdInfoOutline } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaBath, FaBed, FaFileContract, FaRegCalendar } from "react-icons/fa";
import {
  Card,
  CardBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  PopoverBody,
  PopoverHeader,
  Spinner,
  UncontrolledCollapse,
  UncontrolledDropdown,
  UncontrolledPopover,
} from "reactstrap";
import Swal from "sweetalert2";
import PlaceholderImg from "../../assets/placeholder-img.png";
import FloorPlan from "../../assets/images/blueprint.png";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import ErrorComponent from "../../components/error/ErrorComponent";
import DotPagination from "../../components/pagination/DotPaginate";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  deleteListing,
  deleteMultipleListing,
  duplicateListing,
  editListing,
  getListingList,
  handleResetListing,
  permanentDeleteListing,
  permanentDeleteMultipleListing,
  restoreListing,
  restoreMultipleListing,
} from "../../redux/Apislices/listingSlice";
import { removeSession, setSession } from "../../utils/Storage";
import { USDollar, getScreenWidth } from "../../utils/Utils";
import styles from "./assignment.module.scss";
import { BiDuplicate } from "react-icons/bi";
import { getcity } from "../../redux/Apislices/citySlice";
import { getHomeFacts } from "../../redux/Apislices/homeFactsSlice";
import { getParkingList } from "../../redux/Apislices/parkingSlice";
import clsx from "clsx";
import SoldModal from "../../components/assignment/SoldModal";

const assignmentStatusOptions = [
  { value: "active", label: "Active" },
  { value: "on hold", label: "On Hold" },
  { value: "sold", label: "Sold" },
  { value: "under contract", label: "Under Contract" },
  { value: "cancelled", label: "Cancelled" },
];

const statusOptions = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "draft", label: "Draft" },
];

const itemsPerPageOptions = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const bulkActionOptions = [
  { value: "", label: "Bulk Action" },
  { value: "archive", label: "Archive" },
  { value: "delete", label: "Delete" },
];

const bulkRestoreOptions = [
  { value: "", label: "Bulk Action" },
  { value: "restore", label: "Restore" },
  { value: "delete", label: "Delete" },
];

const bedroomsOption = [
  { value: "0", label: "0" },
  { value: "0.5", label: "0.5" },
  { value: "1", label: "1" },
  { value: "1.5", label: "1.5" },
  { value: "2", label: "2" },
  { value: "2.5", label: "2.5" },
  { value: "3", label: "3" },
  { value: "3.5", label: "3.5" },
  { value: "4+", label: "4+" },
];
const bathroomsOption = [
  { value: "0", label: "0" },
  { value: "0.5", label: "0.5" },
  { value: "1", label: "1" },
  { value: "1.5", label: "1.5" },
  { value: "2", label: "2" },
  { value: "2.5", label: "2.5" },
  { value: "3", label: "3" },
  { value: "3.5", label: "3.5" },
  { value: "4+", label: "4+" },
];

const Assignment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { listing, permission, cityData, homeTypeData, parkingData } = useSelector((state) => ({
    listing: state?.listing,
    permission: state?.auth?.profile?.permissions?.assignment,
    homeTypeData: state?.homeType,
    parkingData: state?.parking,
    cityData: state?.city?.cities,
  }));

  const { listings: listingData } = listing;
  console.log("listingData: ", listingData);

  const [selectedData, setSelectedData] = useState([]);
  const [screenWidth, setScreenWidth] = useState(getScreenWidth());
  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);

  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");

  const [limit, setLimit] = useState({ value: 25, label: "25" });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);

  const [sort, setSort] = useState("");
  const [status, setStatus] = useState("");
  const [assignmentStatus, setAssignmentStatus] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [parking, setParking] = useState("");
  const [city, setCity] = useState("");
  const [homeType, setHomeType] = useState("");

  // Sold Modal States
  const [soldDetails, setSoldDetails] = useState({ soldPrice: null, soldDate: null });
  const [price, setPrice] = useState("");
  const [priceError, setPriceError] = useState(false);
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState(false);

  const [modalShow, setModalShow] = useState({ open: false, data: null });

  const [bulkAction, setBulkAction] = useState("");

  useEffect(() => {
    dispatch(getcity());
    dispatch(getHomeFacts());
    dispatch(getParkingList());
  }, [dispatch]);

  useEffect(() => {
    if (typeof limit === "object" && limit?.value) setItemPerPage(limit?.value);
    else setItemPerPage(25);
  }, [limit]);

  const handleGetData = async () => {
    dispatch(
      getListingList({
        status: typeof status === "object" ? status?.value : status,
        assignmentStatus: typeof assignmentStatus === "object" ? assignmentStatus?.value : assignmentStatus,
        type: "assignment",
        page: currentPage,
        limit: itemPerPage,
        search: onSearchText,
        sort,
        bedrooms: typeof bedrooms === "object" ? bedrooms?.value : bedrooms,
        bathrooms: typeof bathrooms === "object" ? bathrooms?.value : bathrooms,
        parking: typeof parking === "object" ? parking?.value : parking,
        city: typeof city === "object" ? city?.value : city,
        homeType: typeof homeType === "object" ? homeType?.value : homeType,
      })
    );
  };

  //debounce getDevelopmentList for search
  useEffect(() => {
    const timer = setTimeout(
      () => {
        handleGetData();
      },
      onSearchText ? 800 : 200
    );
    return () => clearTimeout(timer);
  }, [
    dispatch,
    currentPage,
    itemPerPage,
    onSearchText,
    sort,
    status,
    assignmentStatus,
    bedrooms,
    bathrooms,
    parking,
    city,
    homeType,
  ]);

  // selects all the products
  const selectorCheck = (e) => {
    if (e.currentTarget.checked) setSelectedData(listingData?.data?.map((item) => item._id));
    else setSelectedData([]);
  };

  // selects one product
  const onSelectChange = (e, id) => {
    // add or remove the selected item from selectedData
    if (e.currentTarget.checked) setSelectedData([...selectedData, id]);
    else setSelectedData(selectedData.filter((item) => item !== id));
  };

  // toggle search input
  const toggle = () => setonSearch(!onSearch);

  // bulk action change
  const onActionText = (e) => setBulkAction(e);

  // onChange function for searching name
  const onFilterChange = (e) => setSearchText(e.target.value);

  const handleActiveDevelopment = (data) => {
    let payload = { ...data, type: data?.type };

    if (data?.status === "active") {
      payload.status = "on hold";
    } else if (data?.status === "on hold" || data?.status === "pending") {
      payload.status = "active";
    }

    dispatch(
      editListing(
        data?.slug,
        payload,
        (res) => {
          handleGetData();
        },
        (res) => {
          toast.error(res?.message);
        }
      )
    );
  };

  const handleDuplicateListing = (li) => {
    Swal.fire({
      title: `Are you sure you want to duplicate this listing?`,
      icon: "question",
      confirmButtonText: "Yes",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "No",
      focusConfirm: false,
      confirmButtonColor: "#5a8dee",
      buttonsStyling: {},
    }).then((result) => {
      if (result.isConfirmed) {
        let toastId = toast.loading("Duplicating Listing...");
        dispatch(
          duplicateListing(
            li?._id,
            (res) => {
              console.log("res: ", res);
              toast.dismiss(toastId);
              toast.success("Listing Duplicated!");
              navigate(`/assignment/edit/${res?.data?.slug}`);
            },
            (res) => {
              toast.dismiss(toastId);
              toast.error("Something went wrong!");
            }
          )
        );
      }
    });
  };

  const closeSoldModal = () => {
    setModalShow({ open: false, data: null });
  };
  const submitModal = (data) => {
    let payload = { ...data, assignmentStatus: "sold", soldDetails: { soldPrice: +price, soldDate: date } };
    if (price && date) {
      dispatch(
        editListing(
          data?.slug,
          payload,
          (res) => {
            toast.success("Assignment status changed");
            handleGetData();
            closeSoldModal();
          },
          (res) => {
            toast.error(res?.message);
          }
        )
      );
    } else {
      if (!price) setPriceError(true);
      if (!date) setDateError(true);
    }
  };

  const handleChangeStatus = (stat, data) => {
    console.log("stat: ", stat);

    if (stat === "sold" && (!soldDetails?.soldPrice || !soldDetails?.soldDate)) {
      setModalShow({ open: true, data });
      return;
    } else {
      let payload = { ...data, type: data?.type };
      if (stat) payload.assignmentStatus = stat;
      dispatch(
        editListing(
          data?.slug,
          payload,
          (res) => {
            toast.success("Assignment status changed");
            handleGetData();
          },
          (res) => {
            toast.error(res?.message);
          }
        )
      );
    }
  };

  const handleBulkAction = (e) => {
    if (bulkAction?.value === "archive") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Archive",
      }).then((result) => {
        if (result.isConfirmed) {
          handleArchiveMultiple(
            () => {
              Swal.fire("Archived!", "Selected Assignments has been archived.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (bulkAction?.value === "delete") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDeleteMultiple(
            () => {
              Swal.fire("Deleted!", "Selected Assignments has been deleted.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (bulkAction?.value === "restore") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Restore",
      }).then((result) => {
        if (result.isConfirmed) {
          handleRestoreMultiple(
            () => {
              Swal.fire("Restored!", "Selected Assignments has been restored.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    }
  };

  const handleArchiveMultiple = async (successCB, errorCB) => {
    dispatch(
      deleteMultipleListing(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleRestoreMultiple = async (successCB, errorCB) => {
    dispatch(
      restoreMultipleListing(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleDeleteMultiple = async (successCB, errorCB) => {
    dispatch(
      permanentDeleteMultipleListing(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleArchive = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Archive",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteListing(
            item?._id,
            (res) => {
              console.log("res: ", res);
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Archived!", "Assignment has been archived.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleRestore = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Restore",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          restoreListing(
            item?._id,
            (res) => {
              console.log("res: ", res);
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Archived!", "Assignment has been restored.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          permanentDeleteListing(
            item?._id,
            (res) => {
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Deleted!", "Assignment has been deleted.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Assignments"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Assignments</BlockTitle>
              <BlockDes className="text-soft">
                {listingData?.total?.total ? `Total ${listingData?.total?.total} Assignments` : null}
              </BlockDes>
            </BlockHeadContent>

            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>

                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle btn-icon d-md-none"
                        onClick={() => {
                          dispatch(handleResetListing());
                          removeSession("assignment");
                          removeSession("assign-step");
                          removeSession("assign-max-step");
                          navigate("/assignment/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                      <Button
                        className="toggle d-none btn-outline-primary btn-dim d-md-inline-flex"
                        onClick={() => {
                          dispatch(handleResetListing());
                          removeSession("assignment");
                          removeSession("assign-step");
                          removeSession("assign-max-step");
                          navigate("/assignment/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Assignment</span>
                      </Button>
                    </li>

                    {(typeof status === "object" && status?.value === "archive") || status === "archive" ? (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon btn-outline-info d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-info btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                          <span>All Assignments</span>
                        </Button>
                      </li>
                    ) : (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-danger btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                          <span>Archived</span>
                        </Button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                {/* Bulk Actions */}
                {selectedData.length ? (
                  <div className="card-tools">
                    <div className="form-inline flex-nowrap gx-3">
                      <div className="form-wrap">
                        <RSelect
                          options={
                            (typeof status === "object" && status?.value === "archive") || status === "archive"
                              ? bulkRestoreOptions
                              : bulkActionOptions
                          }
                          className="w-130px"
                          placeholder="Bulk Action"
                          onChange={(e) => onActionText(e)}
                          value={bulkAction}
                        />
                      </div>
                      <div className="btn-wrap">
                        <span className="d-none d-md-block">
                          <Button
                            disabled={selectedData.length && bulkAction?.value ? false : true}
                            color="info"
                            outline
                            className="btn-dim"
                            onClick={(e) => {
                              if (selectedData.length && bulkAction?.value) {
                                handleBulkAction(e);
                              }
                            }}
                          >
                            Apply
                          </Button>
                        </span>
                        <span className="d-md-none">
                          <Button
                            color="info"
                            outline
                            disabled={selectedData.length && bulkAction?.value ? false : true}
                            className="btn-dim btn-icon"
                            onClick={(e) => {
                              if (selectedData.length && bulkAction?.value) {
                                handleBulkAction(e);
                              }
                            }}
                          >
                            <Icon name="arrow-right"></Icon>
                          </Button>
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    {/* Search */}
                    <li>
                      <div
                        className="search-content"
                        style={{
                          border: "1px solid #dbdfea",
                          borderRadius: "4px",
                        }}
                      >
                        <Button
                          className="search-back btn-icon toggle-search active"
                          onClick={() => {
                            setSearchText("");
                            toggle();
                          }}
                        >
                          <Icon name="search"></Icon>
                        </Button>
                        <input
                          type="text"
                          className="border-transparent form-focus-none form-control"
                          placeholder="Search by user or email"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                        {onSearchText ? (
                          <Button
                            className="search-submit btn-icon"
                            onClick={() => {
                              setSearchText("");
                            }}
                          >
                            <Icon name="cross"></Icon>
                          </Button>
                        ) : null}
                      </div>
                    </li>

                    <li className="btn-toolbar-sep"></li>

                    <li>
                      <div className="toggle-wrap">
                        <Button
                          className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                          onClick={() => updateTableSm(true)}
                        >
                          <Icon name="menu-right"></Icon>
                        </Button>
                        <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                          <ul className="btn-toolbar gx-1">
                            <li className="toggle-close">
                              <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                <Icon name="arrow-left"></Icon>
                              </Button>
                            </li>

                            {/* Filter */}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                  {/* <div className="dot dot-primary"></div> */}
                                  <Icon name="filter-fill"></Icon>
                                </DropdownToggle>
                                <DropdownMenu
                                  right
                                  className={clsx("filter-wg dropdown-menu-xl", styles.dropdownMenu)}
                                  style={{
                                    overflow: "visible",
                                    // minWidth: "500px",
                                    // transform: "translate3d(-500px, 50px, 0px)",
                                  }}
                                >
                                  <div className="dropdown-head">
                                    <span className="sub-title dropdown-title">Filter Assignments</span>
                                  </div>
                                  <div className="dropdown-body dropdown-body-rg">
                                    <Row className="gx-6 gy-3">
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Live Status</label>
                                          <RSelect
                                            options={statusOptions}
                                            onChange={(value) => {
                                              setStatus(value);
                                            }}
                                            value={status}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Sale Status</label>
                                          <RSelect
                                            options={[{ value: "", label: "All" }, ...assignmentStatusOptions]}
                                            onChange={(value) => {
                                              setAssignmentStatus(value);
                                            }}
                                            value={assignmentStatus}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Bedrooms</label>
                                          <RSelect
                                            options={[{ value: "", label: "All" }, ...bedroomsOption]}
                                            onChange={(value) => {
                                              setBedrooms(value);
                                            }}
                                            value={bedrooms}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Bathrooms</label>
                                          <RSelect
                                            options={[{ value: "", label: "All" }, ...bathroomsOption]}
                                            onChange={(value) => {
                                              setBathrooms(value);
                                            }}
                                            value={bathrooms}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Home Types</label>
                                          <RSelect
                                            options={
                                              homeTypeData?.homeType?.length
                                                ? [
                                                    { value: "", label: "All" },
                                                    ...homeTypeData?.homeType?.map((item) => ({
                                                      value: item?._id,
                                                      label: item?.name,
                                                    })),
                                                  ]
                                                : []
                                            }
                                            onChange={(value) => {
                                              setHomeType(value);
                                            }}
                                            value={homeType}
                                            placeholder="Select"
                                            isLoading={homeTypeData?.loading}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Parking</label>
                                          <RSelect
                                            options={
                                              parkingData?.parking?.length
                                                ? [
                                                    { value: "", label: "All" },
                                                    ...parkingData?.parking?.map((item) => ({
                                                      value: item?._id,
                                                      label: item?.name,
                                                    })),
                                                  ]
                                                : []
                                            }
                                            onChange={(value) => {
                                              setParking(value);
                                            }}
                                            value={parking}
                                            placeholder="Select"
                                            isLoading={parkingData?.loading}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">City</label>
                                          <RSelect
                                            options={
                                              cityData?.data?.length
                                                ? [
                                                    { value: "", label: "All" },
                                                    ...cityData?.data?.map((item) => ({
                                                      value: item?._id,
                                                      label: item?.name,
                                                    })),
                                                  ]
                                                : []
                                            }
                                            onChange={(value) => {
                                              setCity(value);
                                            }}
                                            value={city}
                                            placeholder="Select"
                                            isLoading={cityData?.loading}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Items Per Page</label>
                                          <RSelect
                                            options={itemsPerPageOptions}
                                            onChange={(value) => {
                                              setLimit(value);
                                            }}
                                            value={limit}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </div>

                                  <div className="dropdown-foot between">
                                    {/* <button type="button" className="btn btn-secondary">
                                      Filter
                                    </button> */}
                                    <span></span>

                                    <a
                                      href="#reset"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setStatus("");
                                        setAssignmentStatus("");
                                        setBedrooms("");
                                        setBathrooms("");
                                        setHomeType("");
                                        setParking("");
                                        setCity("");
                                      }}
                                      className="clickable"
                                    >
                                      Reset Filter
                                    </a>
                                  </div>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>

                            {/* Sort */}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle color="tranparent" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <Icon name="sort-line"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("recently-updated");
                                        }}
                                        className={sort === "recently-updated" ? "text text-primary" : ""}
                                      >
                                        <span>Recently Updated</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("recently-added");
                                        }}
                                        className={sort === "recently-added" ? "text text-primary" : ""}
                                      >
                                        <span>Recently Added</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("oldest");
                                        }}
                                        className={sort === "oldest" ? "text text-primary" : ""}
                                      >
                                        <span>Oldest First</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("asc");
                                        }}
                                        className={sort === "asc" ? "text text-primary" : ""}
                                      >
                                        <span>0-9, A-Z</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("desc");
                                        }}
                                        className={sort === "desc" ? "text text-primary" : ""}
                                      >
                                        <span>9-0, Z-A</span>
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className={`card-search search-wrap `}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {listingData?.loading ? (
              <div
                style={{
                  height: "200px",
                  width: "100%",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Spinner type="grow" color="dark" />
              </div>
            ) : listingData?.success && listingData?.data?.length ? (
              <DataTableBody>
                <DataTableHead>
                  <DataTableRow className="nk-tb-col-check">
                    <div className="custom-control custom-control-sm custom-checkbox notext">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        id="uid_1"
                        checked={listingData?.data
                          ?.map((item) => item._id)
                          .every((item) => selectedData.includes(item))}
                        onChange={(e) => selectorCheck(e)}
                      />
                      <label className="custom-control-label" htmlFor="uid_1"></label>
                    </div>
                  </DataTableRow>
                  <DataTableRow>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Name</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>DOM</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Agent</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Live Status</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Sale Status</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Type</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Price</span>
                  </DataTableRow>
                  {/* <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Price/Sqft</span>
                  </DataTableRow> */}
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Strata</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Hot Sale</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Completion</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Updated On</span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>Views</span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools"></DataTableRow>
                </DataTableHead>
                {listingData?.data?.length
                  ? listingData?.data?.map((item) => {
                      return (
                        <DataTableItem key={item._id}>
                          <DataTableRow className="nk-tb-col-check">
                            <div className="custom-control custom-control-sm custom-checkbox notext">
                              <input
                                type="checkbox"
                                className="custom-control-input form-control"
                                id={item._id + "uid1"}
                                key={Math.random()}
                                checked={selectedData.includes(item._id)}
                                onChange={(e) => onSelectChange(e, item._id)}
                              />
                              <label className="custom-control-label" htmlFor={item._id + "uid1"}></label>
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            <div
                              className="tb-product lazy-image"
                              // style={{  minWidth: "200px",}}
                            >
                              <LazyLoadImage
                                src={
                                  item?.images?.length
                                    ? `${process.env.REACT_APP_IMGURL}${item.images?.[0]}`
                                    : PlaceholderImg
                                }
                                alt="development_image"
                                effect="blur"
                                className="thumb"
                                placeholderSrc={PlaceholderImg}
                                style={{
                                  width: "70px",
                                  height: "45px",
                                  borderRadius: "4px",
                                  objectFit: "cover",
                                }}
                              />
                              <div style={{ display: "flex", flexDirection: "column", fontSize: "12px" }}>
                                <div
                                  className="title"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px",
                                    padding: "0",
                                    margin: "0",
                                  }}
                                >
                                  <span>{item?.title}</span>
                                  <MdInfoOutline
                                    style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px", cursor: "pointer" }}
                                  />
                                  <a
                                    href={`${process.env.REACT_APP_USER_WEB_URL}assignment/${item?.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <ImNewTab style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px" }} />
                                  </a>
                                </div>
                                <span style={{}} className="sub-title">
                                  {item?.address?.firstLine}
                                </span>
                                <span style={{}} className="sub-title">
                                  {item?.address?.neighbourhood?.name}, {item?.address?.city?.name}
                                </span>
                                <span style={{}} className="sub-title">
                                  {item?.development?.name}
                                </span>
                                <ul className={styles.details}>
                                  {item?.bedrooms || item?.bedrooms === 0 ? (
                                    <li>
                                      <FaBed /> <span>{item?.bedrooms}</span>
                                    </li>
                                  ) : null}
                                  {item?.bathrooms ? (
                                    <li>
                                      <FaBath /> <span>{item?.bathrooms}</span>
                                    </li>
                                  ) : null}
                                  {item?.floorArea ? (
                                    <li>
                                      <img src={FloorPlan} alt="icon" style={{ width: "12 px", height: "12px" }} />
                                      <span>{item?.floorArea} sqft</span>
                                    </li>
                                  ) : null}
                                  <li>
                                    <FaRegCalendar /> <span>{item?.construction?.end?.year}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <p className="tb-sub">{moment(Date.now()).diff(moment(item?.publishDate), "days")}</p>
                          </DataTableRow>
                          <DataTableRow>
                            <div className="tb-sub" style={{ textAlign: "center" }}>
                              <p style={{ margin: "0" }}>{`${item?.user?.firstName} ${item?.user?.lastName}`}</p>
                              {item?.user?.vipAgent?.isVip === "yes" ? (
                                <p style={{ color: "#00e200", fontWeight: "500" }}>VIP</p>
                              ) : (
                                ""
                              )}
                            </div>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <p
                              className="tb-sub"
                              style={{
                                color: item?.isDeleted
                                  ? "#FF2A04"
                                  : item?.status === "active"
                                  ? "#00E200"
                                  : item?.status === "sold"
                                  ? "#FF2A04"
                                  : item?.status === "pending"
                                  ? "#FFAF3D"
                                  : item?.status === "draft"
                                  ? "#7B8089"
                                  : item?.status === "on hold"
                                  ? "#285766"
                                  : "",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0",
                                padding: "0",
                                margin: "0",
                                textAlign: "center",
                                textTransform: "capitalize",
                                width: "100%",
                              }}
                            >
                              {item?.isDeleted ? "Archived" : item?.status}
                            </p>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <p
                              className="tb-sub"
                              style={{
                                color:
                                  item?.assignmentStatus === "active"
                                    ? "#00E200"
                                    : item?.assignmentStatus === "sold"
                                    ? "#FF2A04"
                                    : item?.assignmentStatus === "draft"
                                    ? "#FFAF3D"
                                    : item?.assignmentStatus === "under contract"
                                    ? "#FFAF3D"
                                    : item?.assignmentStatus === "draft"
                                    ? "#7B8089"
                                    : item?.assignmentStatus === "on hold"
                                    ? "#285766"
                                    : "",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0",
                                padding: "0",
                                margin: "0",
                                textTransform: "capitalize",
                              }}
                            >
                              <span>{item?.assignmentStatus}</span>
                            </p>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{item?.homeType?.name}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">
                              {item?.price?.askingPrice ? USDollar(item?.price?.askingPrice) : ""}
                            </span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{USDollar(item?.price?.strata?.cost, true)}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{item?.price?.hotSale ? "Yes" : "No"}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{item?.construction?.end?.year}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{moment(item?.updatedAt).format("DD/MM/YYYY")}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{item?.views}</span>
                          </DataTableRow>
                          <DataTableRow className="nk-tb-col-tools">
                            <ul className="nk-tb-actions gx-1 my-n1">
                              <li className="mr-n1">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    href="#more"
                                    onClick={(ev) => ev.preventDefault()}
                                    className="dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <ul className="link-list-opt no-bdr">
                                      {(typeof status === "object" && status?.value === "archive") ||
                                      status === "archive" ? (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#view"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleRestore(item);
                                            }}
                                            disabled={permission && !permission?.edit}
                                          >
                                            {/* <Icon name="archived-fill"></Icon> */}
                                            <LuArchiveRestore
                                              style={{
                                                fontSize: "18px",
                                                marginRight: "15px",
                                                color: "#526484",
                                              }}
                                            />
                                            <span>Restore</span>
                                          </DropdownItem>
                                        </li>
                                      ) : (
                                        <>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href={`#edit`}
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                dispatch(handleResetListing());
                                                removeSession("assignment");
                                                removeSession("assign-step");
                                                removeSession("assign-max-step");
                                                navigate(`/assignment/edit/${item?.slug}`);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="edit"></Icon>
                                              <span>Edit this Assignment</span>
                                            </DropdownItem>
                                          </li>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href={`#edit`}
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleDuplicateListing(item);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="copy"></Icon>
                                              <span>Duplicate this Assignment</span>
                                            </DropdownItem>
                                          </li>
                                          <li>
                                            <Button
                                              id={"toggler"}
                                              className={styles.btn}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="chevron-down" className={styles.icon}></Icon>
                                              <span>Change Assignment Status</span>
                                            </Button>
                                            <UncontrolledCollapse toggler="#toggler">
                                              <Card>
                                                <CardBody className={styles.cardBody}>
                                                  <ul>
                                                    {assignmentStatusOptions
                                                      ?.filter((li) => li.value !== item?.assignmentStatus)
                                                      ?.map((li, i) => (
                                                        <li
                                                          key={i}
                                                          onClick={() => {
                                                            handleChangeStatus(li?.value, item);
                                                          }}
                                                        >
                                                          {li?.label}
                                                        </li>
                                                      ))}
                                                  </ul>
                                                </CardBody>
                                              </Card>
                                            </UncontrolledCollapse>
                                          </li>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleActiveDevelopment(item);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="eye"></Icon>
                                              <span>
                                                {item?.status === "active" ? "Put On Hold" : "Make It Active"}
                                              </span>
                                            </DropdownItem>
                                          </li>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleArchive(item);
                                              }}
                                              disabled={permission && !permission?.archive}
                                            >
                                              <Icon name="archived-fill"></Icon>
                                              <span>Archive</span>
                                            </DropdownItem>
                                          </li>
                                        </>
                                      )}

                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#view"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            handleDelete(item);
                                          }}
                                          disabled={permission && !permission?.delete}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete Permanently</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                  : null}
              </DataTableBody>
            ) : listingData?.success && !listingData?.data?.length ? (
              <div
                className="text-center"
                style={{
                  padding: "20px",
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
              >
                <span className="text-silent">No Assignments found</span>
              </div>
            ) : listingData?.error ? (
              <ErrorComponent error={listingData?.error} />
            ) : null}
            <div className="card-inner p-0">
              {listingData?.success && listingData?.data?.length ? (
                <DotPagination
                  itemPerPage={listingData?.total?.items_per_page}
                  totalItems={listingData?.total?.total}
                  paginate={paginate}
                  currentPage={currentPage}
                  siblingCount={2}
                  screenWidth={screenWidth}
                />
              ) : null}
            </div>
          </DataTable>
        </Block>

        <SoldModal
          isOpen={modalShow.open}
          data={modalShow.data}
          toggle={() => setModalShow({ open: false, data: null })}
          handleSubmit={submitModal}
          price={price}
          setPrice={setPrice}
          priceError={priceError}
          setPriceError={setPriceError}
          date={date}
          setDate={setDate}
          dateError={dateError}
          setDateError={setDateError}
        />
      </Content>
    </React.Fragment>
  );
};

export default Assignment;
